var _rect, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: "custom-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_585",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 25C20.7167 25 20.4792 24.9042 20.2875 24.7125C20.0958 24.5208 20 24.2833 20 24V17.825L18.125 19.7C17.9417 19.8833 17.7125 19.975 17.4375 19.975C17.1625 19.975 16.925 19.8833 16.725 19.7C16.525 19.5 16.425 19.2625 16.425 18.9875C16.425 18.7125 16.525 18.475 16.725 18.275L20.3 14.7C20.4 14.6 20.5083 14.5292 20.625 14.4875C20.7417 14.4458 20.8667 14.425 21 14.425C21.1333 14.425 21.2583 14.4458 21.375 14.4875C21.4917 14.5292 21.6 14.6 21.7 14.7L25.3 18.3C25.5 18.5 25.5958 18.7333 25.5875 19C25.5792 19.2667 25.475 19.5 25.275 19.7C25.075 19.8833 24.8417 19.9792 24.575 19.9875C24.3083 19.9958 24.075 19.9 23.875 19.7L22 17.825V24C22 24.2833 21.9042 24.5208 21.7125 24.7125C21.5208 24.9042 21.2833 25 21 25ZM27 33.575C26.8667 33.575 26.7417 33.5542 26.625 33.5125C26.5083 33.4708 26.4 33.4 26.3 33.3L22.7 29.7C22.5 29.5 22.4042 29.2667 22.4125 29C22.4208 28.7333 22.525 28.5 22.725 28.3C22.925 28.1167 23.1583 28.0208 23.425 28.0125C23.6917 28.0042 23.925 28.1 24.125 28.3L26 30.175V24C26 23.7167 26.0958 23.4792 26.2875 23.2875C26.4792 23.0958 26.7167 23 27 23C27.2833 23 27.5208 23.0958 27.7125 23.2875C27.9042 23.4792 28 23.7167 28 24V30.175L29.875 28.3C30.0583 28.1167 30.2875 28.025 30.5625 28.025C30.8375 28.025 31.075 28.1167 31.275 28.3C31.475 28.5 31.575 28.7375 31.575 29.0125C31.575 29.2875 31.475 29.525 31.275 29.725L27.7 33.3C27.6 33.4 27.4917 33.4708 27.375 33.5125C27.2583 33.5542 27.1333 33.575 27 33.575Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapVertical);
export default __webpack_public_path__ + "static/media/swapVertical.da4a8d4f4ab2c7e5576e9a6653ba94eb.svg";
export { ForwardRef as ReactComponent };